var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "market" }, [
    _vm.market
      ? _c(
          "div",
          {
            class: [
              "market",
              "big3",
              _vm.big3markettype,
              { suspended: !_vm.market.istradable },
              { "two-selections": _vm.market.selections.length === 2 },
              { "same-prices": _vm.isSamePrice }
            ],
            attrs: {
              idfomarket: _vm.market.idfomarket,
              isfrompush: (_vm.market.V !== undefined).toString()
            }
          },
          [
            _vm.showheader === undefined || _vm.showheader
              ? _c("div", { staticClass: "header" }, [
                  _c("div", { staticClass: "market-name" }, [
                    _vm.big3markettype === "TP"
                      ? _c(
                          "h4",
                          { staticClass: "market-name-title text-overflow" },
                          [_vm._v(_vm._s(_vm.$t("Market.TOTAL")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.big3markettype === "PS"
                      ? _c(
                          "h4",
                          { staticClass: "market-name-title text-overflow" },
                          [_vm._v(_vm._s(_vm.$t("Market.SPREAD")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.big3markettype === "ML"
                      ? _c(
                          "h4",
                          { staticClass: "market-name-title text-overflow" },
                          [_vm._v(_vm._s(_vm.$t("Market.MONEY")))]
                        )
                      : _vm._e()
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isDebug
              ? _c("div", { staticClass: "debug" }, [
                  _vm._v("\n      " + _vm._s(_vm.market.idfomarket)),
                  _c("br"),
                  _vm._v(
                    "\n      isfrompush " +
                      _vm._s((_vm.market.V !== undefined).toString()) +
                      "\n    "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "selections-container" }, [
              _vm.market.selections && _vm.isHadMarket
                ? _c("div", { staticClass: "selections had" }, [
                    _c(
                      "div",
                      {
                        class: [
                          "selections",
                          {
                            hasdraw:
                              _vm.market.selections.filter(function(sel) {
                                return sel.hadvalue === "D"
                              }).length > 0
                          },
                          {
                            handicap:
                              _vm.market.name
                                .toLowerCase()
                                .indexOf("handicap") > -1
                          }
                        ]
                      },
                      _vm._l(["A", "H", "O", "U"], function(hadvalue, index) {
                        return _vm.selectionsGroupedByHadType[hadvalue].length
                          ? _c(
                              "div",
                              {
                                key: index,
                                staticClass: "selection",
                                class: hadvalue
                              },
                              _vm._l(
                                _vm.selectionsGroupedByHadType[hadvalue],
                                function(selection) {
                                  return _c(
                                    "div",
                                    {
                                      key: selection.idfoselection,
                                      staticClass: "selection-column"
                                    },
                                    [
                                      _c("selection", {
                                        attrs: {
                                          selection: selection,
                                          istradable: _vm.market.istradable,
                                          showselectionname: false,
                                          ishad: true
                                        }
                                      })
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e()
                      }),
                      0
                    )
                  ])
                : _c("div", [_vm._v("\n         EMPTY\n      ")])
            ])
          ]
        )
      : _c(
          "div",
          {
            staticClass: "market big3 two-selections empty",
            attrs: { idfomarket: "null", isfrompush: "false" }
          },
          [
            _vm.showheader === undefined || _vm.showheader
              ? _c("div", { staticClass: "header" }, [
                  _c("div", { staticClass: "market-name" }, [
                    _vm.big3markettype === "TP"
                      ? _c(
                          "h4",
                          { staticClass: "market-name-title text-overflow" },
                          [_vm._v(_vm._s(_vm.$t("Market.TOTAL")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.big3markettype === "PS"
                      ? _c(
                          "h4",
                          { staticClass: "market-name-title text-overflow" },
                          [_vm._v(_vm._s(_vm.$t("Market.SPREAD")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.big3markettype === "ML"
                      ? _c(
                          "h4",
                          { staticClass: "market-name-title text-overflow" },
                          [_vm._v(_vm._s(_vm.$t("Market.MONEY")))]
                        )
                      : _vm._e()
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "selections-container" }, [
              _vm.brand_white1 || _vm.brand_translux5
                ? _c("div", { staticClass: "selections had" }, [_vm._m(0)])
                : _c("div", { staticClass: "selectionprice" })
            ])
          ]
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "selections" }, [
      _c("div", { staticClass: "selection" }, [
        _c("div", { staticClass: "selection-column" }, [
          _c("div", { staticClass: "selection-component" }, [
            _c("div", { staticClass: "value" }, [
              _c("div", { staticClass: "selectionprice" })
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "selection" }, [
        _c("div", { staticClass: "selection-column" }, [
          _c("div", { staticClass: "selection-component" }, [
            _c("div", { staticClass: "value" }, [
              _c("div", { staticClass: "selectionprice" })
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05911d61", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05911d61","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bettingoffer/big3market.vue
// module id = null
// module chunks = 